import React, { useState } from 'react';
import cn from 'classnames';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import Icon from '../../../components/Icon';
import { showSuccess, showError } from '../../../services/toast.service';
import { getCompanyBySiret } from '../../../services/getSiret.service';
import styles from './AddressInformations.module.sass';

const SearchCompany = ({ company, onCompanyChange }) => {
  const [siret, setSiret] = useState("");
  const [loadingSiret, setLoadingSiret] = useState(false);

  const handleSiretSearch = async () => {
    if (!siret || siret.length !== 14) {
      showError("Le SIRET doit contenir exactement 14 chiffres");
      return;
    }

    setLoadingSiret(true);

    try {
      const companyInfo = await getCompanyBySiret(siret);
      
      // Mapper les données de l'API Sirene vers le format du formulaire
      const data = companyInfo.data || companyInfo; // Extraire les données du wrapper
      
      const fullAddress = [
        data.numeroVoieEtablissement,
        data.typeVoieEtablissement,
        data.libelleVoieEtablissement
      ].filter(Boolean).join(' ');

      const mappedData = {
        siret: data.siret || siret,
        siren: data.siren || "",
        name: data.denominationUniteLegale || "",
        corporate_name: data.denominationUniteLegale || "",
        legal_form: data.categorieJuridiqueUniteLegale || "",
        naf_code: data.activitePrincipaleUniteLegale || "",
        address: fullAddress,
        zip_code: data.codePostalEtablissement || "",
        city: data.libelleCommuneEtablissement || "",
        creation_date: data.dateCreationUniteLegale || "",
        employee_count: data.trancheEffectifsUniteLegale || "",
        status: data.etatAdministratifUniteLegale || ""
      };

      // Appeler onCompanyChange pour chaque champ pour pré-remplir le formulaire
      Object.entries(mappedData).forEach(([key, value]) => {
        onCompanyChange({ target: { name: key, value } });
      });

      showSuccess("Informations de l'entreprise récupérées avec succès!");
      
    } catch (error) {
      console.error("Erreur lors de la récupération des informations SIRET:", error);
      showError(error.message || "Erreur lors de la récupération des informations de l'entreprise");
    } finally {
      setLoadingSiret(false);
    }
  };

  return (
    <>
      {/* Section SIRET pour récupération automatique */}
      <Card className={styles.card} title="Récupération automatique des informations" classTitle="title-blue">
        <div className={styles.siretInput}>
          <div className={styles.field}>
            <TextInput
              label="Numéro SIRET"
              type="text"
              value={siret}
              onChange={(e) => setSiret(e.target.value.replace(/\D/g, '').slice(0, 14))}
              placeholder="Saisissez le SIRET (14 chiffres)"
              maxLength="14"
            />
          </div>
          <button
            type="button"
            className={cn("button", styles.siretButton)}
            onClick={handleSiretSearch}
            disabled={loadingSiret || siret.length !== 14}
          >
            {loadingSiret ? (
              <>
                <Icon name="loader" />
                Recherche...
              </>
            ) : (
              <>
                <Icon name="search" />
                Rechercher
              </>
            )}
          </button>
        </div>
      </Card>     
    </>
  );
};

export default SearchCompany;
